import React, { useContext } from "react";

import { GlobalContext, OpinionConsumer, OpinionProvider } from "@/contexts";
import { Opinion, OpinionResult } from "@/service/Model";

import MeterAssembler from "./MeterAssembler";
import { MeterWrapper } from "./styles";

type MeterProps = {
  interaction: Opinion;
  interactionResults: OpinionResult;
};

const MeterContainer: React.FC<MeterProps> = ({
  interaction,
  interactionResults,
}) => {
  const globalContext = useContext(GlobalContext);

  return (
    <MeterWrapper>
      <OpinionProvider
        interaction={interaction}
        interactionResults={interactionResults}
        preview={!!globalContext.query.preview}
      >
        <OpinionConsumer>
          {({ opinionValue, onMeterAnswer }) => (
            <MeterAssembler
              interaction={interaction}
              interactionResults={interactionResults}
              previousAnswer={opinionValue?.answer}
              icons={globalContext.icons}
              tealiumConfig={globalContext.tealiumConfig}
              onAnswer={(answer: number) =>
                onMeterAnswer(interaction.id, answer)
              }
            />
          )}
        </OpinionConsumer>
      </OpinionProvider>
    </MeterWrapper>
  );
};

export default MeterContainer;
